import { MeshGradient } from "@paper-design/shaders-react";
import { useEffect, useState } from "react";

/*
 * The desk the whole OS sits on: a slow WebGL mesh gradient with a film grain,
 * low contrast on purpose, so glass panes above it have something to blur.
 * Paper Shaders (https://shaders.paper.design): MeshGradient with grainOverlay.
 */

const LIGHT = ["#f6f4ef", "#e9edf5", "#f3e9dc", "#eef1ec"];
const DARK = ["#0f0f12", "#1a1826", "#20190f", "#10161a"];

function isDark(): boolean {
  const t = document.documentElement.dataset.theme;
  return t ? t === "dark" : matchMedia("(prefers-color-scheme: dark)").matches;
}

export function Backdrop() {
  const [dark, setDark] = useState(isDark);
  const [still, setStill] = useState(() => matchMedia("(prefers-reduced-motion: reduce)").matches);

  useEffect(() => {
    const scheme = matchMedia("(prefers-color-scheme: dark)");
    const motion = matchMedia("(prefers-reduced-motion: reduce)");
    const sync = () => setDark(isDark());
    const observer = new MutationObserver(sync);
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ["data-theme"] });
    scheme.addEventListener("change", sync);
    const onMotion = () => setStill(motion.matches);
    motion.addEventListener("change", onMotion);
    return () => {
      observer.disconnect();
      scheme.removeEventListener("change", sync);
      motion.removeEventListener("change", onMotion);
    };
  }, []);

  return (
    <div aria-hidden className="pointer-events-none fixed inset-0 z-0">
      <MeshGradient
        colors={dark ? DARK : LIGHT}
        distortion={0.85}
        swirl={0.12}
        grainMixer={0.18}
        grainOverlay={dark ? 0.22 : 0.16}
        speed={still ? 0 : 0.12}
        style={{ width: "100%", height: "100%" }}
      />
    </div>
  );
}
